import { createApp } from 'vue'
import App from './App.vue'
import VueNotificationList from '@dafcoe/vue-notification'

// import fontAwesome
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

import { faRedo, faArrowRight, faArrowRightFromBracket, faCheck, faEye } from '@fortawesome/free-solid-svg-icons'

library.add(faRedo, faArrowRight, faArrowRightFromBracket, faCheck, faEye )

// create App
createApp(App)
    .use(VueNotificationList)
    .component('font-awesome-icon', FontAwesomeIcon)
    .mount('#app')
